// src/pages/admin/AdminInvoices.js
// Maxula
import React, { useEffect, useState } from 'react';
import { FiDownload, FiFileText } from 'react-icons/fi';
import { invoiceAPI } from '../../services/api';
import { downloadInvoice } from '../merchant/Invoices';

const fmt = (v) => (Number(v) || 0).toLocaleString('fr-FR');

// Panneau reutilisable : charge et affiche les factures (sans titre de page).
// Utilise dans l'onglet "Factures" de la page Commandes (fusion) ET en page seule.
export const AdminInvoicesPanel = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try { const res = await invoiceAPI.adminList(); setInvoices(res.data?.data || []); }
      catch (e) {} finally { setLoading(false); }
    })();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center py-20">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-600" />
      </div>
    );
  }

  const exportCsv = async () => {
    try {
      const res = await invoiceAPI.adminExport();
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'text/csv' }));
      const a = document.createElement('a');
      a.href = url; a.download = `maxula-factures-${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) { /* silencieux */ }
  };

  return (
    <div>
      <div className="flex justify-end mb-3">
        <button onClick={exportCsv}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-50">
          <FiDownload size={16} /> Exporter (CSV)
        </button>
      </div>
      <div className="overflow-x-auto bg-white rounded-xl border border-gray-200">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 text-gray-600">
            <tr>
              <th className="px-4 py-3 text-left">N°</th>
            <th className="px-4 py-3 text-left">Marchand / Client</th>
            <th className="px-4 py-3 text-left">Date</th>
            <th className="px-4 py-3 text-right">TTC</th>
            <th className="px-4 py-3 text-right">PDF</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {invoices.map((inv) => (
            <tr key={inv._id} className="hover:bg-gray-50">
              <td className="px-4 py-3 font-medium inline-flex items-center gap-2"><FiFileText className="text-gray-400" /> {inv.invoiceNumber}</td>
              <td className="px-4 py-3">{inv.merchantId?.businessName || inv.customerName || '—'}</td>
              <td className="px-4 py-3 text-gray-500">{new Date(inv.issuedAt).toLocaleDateString('fr-FR')}</td>
              <td className="px-4 py-3 text-right font-semibold">{fmt(inv.totalTTC)} MAD</td>
              <td className="px-4 py-3 text-right">
                <button onClick={() => downloadInvoice(inv)} className="p-2 text-primary-600 hover:bg-primary-50 rounded"><FiDownload size={16} /></button>
              </td>
            </tr>
          ))}
          {invoices.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-gray-400">Aucune facture.</td></tr>}
        </tbody>
      </table>
      </div>
    </div>
  );
};

const AdminInvoices = () => (
  <div className="p-6">
    <h1 className="text-3xl font-bold text-gray-900 mb-6">Factures</h1>
    <AdminInvoicesPanel />
  </div>
);

export default AdminInvoices;
